import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AnalyticsDashboardDto } from './analytics-api.types';

@Injectable({ providedIn: 'root' })
export class AnalyticsApiService {
  constructor(private readonly http: HttpClient) {}

  getDashboard(): Observable<AnalyticsDashboardDto> {
    return this.http.get<AnalyticsDashboardDto>('/api/analytics/dashboard');
  }
}
